export default __webpack_public_path__ + "static/media/auth-new-intro-1.69d660ff.svg";